import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/radix/tooltip";
import { GallerySmall } from "@/components/sup/gallery/small";
import { Bed, Compass, ShowerHead } from "lucide-react";
import React from "react";
import { type Configuration } from ".";

type SellerProjectCardProps = {
	config: Configuration;
	isActive?: boolean;
	isShortlisted?: boolean;
	onShortlist?: (propertyId: string) => void;
	isMobileView?: boolean;
};

export const ConfigurationCard = React.memo(function ConfigurationCard({
	config,
	isActive = true,
	isMobileView: _isMobileView = false,
}: SellerProjectCardProps) {
	const {
		price,
		bedrooms,
		bathrooms,
		facing,
		builtupArea,
		basePrice,
		image,
		// plotArea,
	} = config;

	return (
		<TooltipProvider>
			<div className={`w-full ${!isActive ? "hidden" : ""}`}>
				<div>
					{/* Card Container */}
					<div className="">
						{/* Image Container */}
						<div className="relative aspect-square">
							<GallerySmall
								mediaList={[{ url: image, type: "image", name: "", space: "" }]}
								type="unit"
								className="h-full"
							/>

							{/* Property info overlay */}
							<div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/70 to-transparent text-white p-4 pt-8">
								<div className="flex items-center justify-between">
									<div className="flex-1">
										<div className="text-lg font-semibold">{price}</div>
										{basePrice && <div className="text-sm opacity-90">₹{basePrice}/sqft</div>}
									</div>
									<div className="text-right text-sm">
										<div>{bedrooms ? `${bedrooms} bed${bedrooms > 1 ? "s" : ""}` : "Studio"}</div>
										<div className="opacity-90">{builtupArea || "N/A"} sqft</div>
									</div>
								</div>
							</div>
						</div>

						{/* Content */}
						<div className="p-4">
							{/* Amenities/Features */}
							<div className="flex items-center gap-4 text-gray-600 text-sm mb-3">
								{bedrooms && (
									<Tooltip>
										<TooltipTrigger asChild>
											<div className="flex items-center cursor-help">
												<Bed className="w-4 h-4 mr-1" />
												<span>{bedrooms}</span>
											</div>
										</TooltipTrigger>
										<TooltipContent>
											<p>{`${bedrooms} ${bedrooms > 1 ? "Bedrooms" : "Bedroom"}`}</p>
										</TooltipContent>
									</Tooltip>
								)}
								{bathrooms && (
									<Tooltip>
										<TooltipTrigger asChild>
											<div className="flex items-center cursor-help">
												<ShowerHead className="w-4 h-4 mr-1" />
												<span>{bathrooms}</span>
											</div>
										</TooltipTrigger>
										<TooltipContent>
											<p>{`${bathrooms} ${bathrooms > 1 ? "Bathrooms" : "Bathroom"}`}</p>
										</TooltipContent>
									</Tooltip>
								)}
								{facing && (
									<Tooltip>
										<TooltipTrigger asChild>
											<div className="flex items-center cursor-help">
												<Compass className="w-4 h-4 mr-1" />
												<span>{facing.charAt(0).toUpperCase()}</span>
											</div>
										</TooltipTrigger>
										<TooltipContent>
											<p>{`${facing} Facing`}</p>
										</TooltipContent>
									</Tooltip>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</TooltipProvider>
	);
});
